import { ShoppingList } from "@/components/meal-plan/shopping-list";

export function ShoppingPage() {
  return <ShoppingList />;
}
